/**
 * Admin User View Configuration
 *
 * Configuration for admin viewing a user's portfolio at /admin/users/:userId/dashboard.
 * Same columns as user dashboard - admin-specific UI is handled by wrapper component.
 */

import { PortfolioTableConfig } from "./types";

/**
 * Admin user view configuration.
 *
 * To customize columns: Edit the `columns` array below.
 * Column IDs must match keys in columnDefinitions.
 */
export const adminUserConfig: PortfolioTableConfig = {
  id: "admin-user",

  columns: [
    "symbol",
    "currency",
    "secType",
    "qty",
    "mktValueLocal",
    "costBasisLocal",
    "unrealizedPnlUsd",
    "mktValueUsd",
    "currentWeightPct",
    "minSize",
    "rawTargetQty",
  ],

  expandedColumns: ["mktPrice", "priceUsd", "sector", "group", "conId"],

  features: {
    search: true,
    filters: true,
    grouping: true,
    export: true,
  },

  dataRequirements: {
    positions: true,
    accountSummary: true,
    batchPrices: true,
    targetPortfolio: false,
    includeSynthetics: false,
    tradableTimes: true,
  },
};
